import { Component, OnInit } from '@angular/core';
import { AlertController, ModalController, NavParams } from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-interest',
  templateUrl: './interest.page.html',
  styleUrls: ['./interest.page.scss'],
})
export class InterestPage implements OnInit {
  protected saveChangesButton : boolean = false;

  protected nextButtonHidden : boolean = true;

  protected userData : any; //var for logged 'user' data

  protected newGenericOptions : any;  //takes every interest chosen by user (ionViewDidLoad())

  protected firstSetup : boolean;

  constructor(public alertCtrl: AlertController, public navParams: NavParams,private translate: TranslateService, private modalCtrl: ModalController) {
    this.userData = this.navParams.get('theSoul'); //getting 'user' data
    this.newGenericOptions = new Set(this.userData.interest2);
    this.firstSetup = this.navParams.get('firstSetup');

  }
  ngOnInit(): void {
  }


  //gets selected option from button
  setNewOption(value : string){
    
    this.showSaveButton();

    //verifica se ta no array de interesses ja
    if(!this.hasOption(value)){
      this.addOption(value);  //e vai la e adiciona
    } else {
      this.removeOption(value);
    }

  }

  //closes modal without saving
  exitButton(){
    this.modalCtrl.dismiss('exitModal');
  }

  //switches 'exitButton' to 'saveButton'
  showSaveButton(){
    this.saveChangesButton = true;
  }

  //saves changes made by user
  saveButton(){
    this.saveSelection();
    this.modalCtrl.dismiss('exitModal');    

  }

  //checks if 'newOption' was already in array
  hasOption(newOption : string){
    return this.newGenericOptions.has(newOption);
  }

  //adds option into 'newGenericOptions'
  addOption(chosenOption : string){
    this.newGenericOptions.add(chosenOption);
  }

  //removes option from 'newOption'
  removeOption(chosenOption : string){
    this.newGenericOptions.delete(chosenOption);
  }


  //sets 'nextButton's visibility
  hideNextButton(choice : boolean){
    this.nextButtonHidden = choice;
  }

  async showModalAlert(message: any) {
    let alert = this.alertCtrl.create({
      //title: this.translate.instant('statisticalOnly'),
      subHeader: message,
      buttons: [
        // {
        //   text: this.translate.instant('cancel'),
        //   handler: () => {
        //     console.log('cancel clicked');
        //     return;

        //   }
        // },
        {
          text: 'OK',
          handler: () => { }
        }
      ]
    });

    (await alert).present();
  }

  //"goes back" 1 modal and doesn't save
  backButton(){
    if(this.firstSetup && !this.saveSelection()){
      this.showModalAlert(this.translate.instant("forgotToChoose"));
    } else{
      this.saveSelection();
      this.modalCtrl.dismiss('backModal');  
    }
  }

  //saves info, checks if interest is empty, and closes modal
  nextButton(){
    if(this.firstSetup && !this.saveSelection()){
      this.showModalAlert(this.translate.instant("forgotToChoose"));
    } else{
      this.saveSelection();
      this.modalCtrl.dismiss('nextModal');  
    }
      
  }

  saveSelection(){
    if(this.newGenericOptions.size != 0){  //if user doesn't un-select every option
      this.userData.interest2 = [];     //it empties 'genericOption'
      
      for (let i = 0; i < this.newGenericOptions.size; i++) {    //goes through 'newGenericOptions'
        this.userData.interest2[i] = Array.from(this.newGenericOptions)[i];    //and adds its values into 'genericOption'
      }

      return true;

    } else {
      return false;
    }
    
    //if user un-selects everything, the standard will still be 'genericOption'

    //console.log('settado: ', this.userData.interest2);
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad InterestPage');
  }


}
